import { useContext, useState } from "react";
import { useGetVisualUnitsMutation, useUpdateSelectedVisualUnitsMutation } from "../Redux/Workspace/workspaceActionsSlice";
import { FoundationsGenericToaster } from "./FoundationsGenericToaster";
import { SearchListCallbacks } from "./searchlistCallbacks";
import { AttachExistingReportContext } from "../Pages/Workspace/workspace";
import { FoundationsEnums } from "../enum";
import { FoundationsConstants } from "../FoundationsConstants";
interface VisualUnit {
    VisualUnitId: number;
    Name: string;
    ViewerType?: string;
    basevu?: {
        VisualUnitId: number;
    };
}

interface VisualUnitResponse {
    KeyValue: string;
    DisplayText: string;
    ViewerType: number;
    DisplayDesc: string;
}

interface UpdatedVisualUnits {
    addedVUlist: VisualUnit[];
    detachedVUlist: VisualUnit[];
}
export const attachExistingReportsCallback = (WorkspaceId: number): SearchListCallbacks => {
    const [getVisualUnits] = useGetVisualUnitsMutation();
    const [visualUnitsTable, setVisualUnitsTable] = useState<VisualUnit[]>([])
    const [gaugeSummaryBlockView, setGaugeSummaryBlockView] = useState<VisualUnit[]>([])
    const { setAttachExistingReportData } = useContext(AttachExistingReportContext)
    const [updateSelectedVisualUnits] = useUpdateSelectedVisualUnitsMutation()

 const isSummaryReport = (VUdata: any) => {  //Adding method here as isSummary from VisuaUnitHelper have extra check for X and Y axis
    //need to investigate and resolve backend Summary Report labeling issue 
 if(VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU ||
        VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkList ||
        VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge)
            {
        return true
    }
    return false
 }
    const onFind = async (filterText: string) => {
        const formData = new FormData();
        formData.append('searchCriteria', 'searchString');
        formData.append('searchValue', filterText);
        const response = await getVisualUnits(formData).unwrap();
        return response.map((item: VisualUnitResponse) => ({
            KeyValue: item.KeyValue,
            DisplayText: item.DisplayText,
            DisplayDesc: isSummaryReport(item) ? "Summary Report" : "",
            isSummarydiv: true,
        }));
    };



    const onSave = async (selectedItems: any[]) => {
        handleUpdateSelectedVisualUnits(selectedItems).then((response) => {
            if (response) {
                silentRefreshAttachedDetached(response)
            } else {
            FoundationsGenericToaster('error',  FoundationsConstants.toastrMessage.reportcreationfailure);
            }
        })

    };

    const handleUpdateSelectedVisualUnits = (
        filtervalue: VisualUnitResponse[]
    ) => {
        const payload = {
            WorkspaceId: WorkspaceId?.toString() || '',
            VisualUnits: filtervalue.map((x) => ({
                VisualUnitId: Number(x.KeyValue),
                Name: x.DisplayText,
            })),
        };

        const formData = new FormData();
        formData.append('WorkspaceId', payload.WorkspaceId);

        payload.VisualUnits.forEach((unit, index) => {
            if (unit.VisualUnitId) {
                formData.append(`VisualUnits[${index}].VisualUnitId`, String(unit.VisualUnitId));
                formData.append(`VisualUnits[${index}].Name`, unit.Name);
            }
        });

        return updateSelectedVisualUnits(formData)
            .unwrap()
            .then((response: any) => {
                if (response?.statusCode === 201 && response.data?.length > 0) {
                    const addedVUlist = response.data.filter((x: any) => !x.detached);
                    const detachedVUlist = response.data.filter((x: any) => x.detached);
                    return { addedVUlist, detachedVUlist };
                }
                return null;
            })
            .catch(() => null);
    };



    const silentRefreshAttachedDetached = (VUList: UpdatedVisualUnits) => {
        const { addedVUlist, detachedVUlist } = VUList;

        // Handle added visual units
        let newVisualUnits = [...visualUnitsTable];
        let newGaugeSummaryBlockView = [...gaugeSummaryBlockView];

        if (addedVUlist.length > 0) {
            newVisualUnits = [...visualUnitsTable, ...addedVUlist];
            const svuUnits = addedVUlist.filter((vu) => vu.ViewerType === 'SVU');
            newGaugeSummaryBlockView = [...gaugeSummaryBlockView, ...svuUnits];
        }

        // Handle detached visual units
        if (detachedVUlist.length > 0) {
            newVisualUnits = newVisualUnits.filter(
                (vu) => !detachedVUlist.some((det) => det.basevu?.VisualUnitId === vu.basevu?.VisualUnitId)
            );
            newGaugeSummaryBlockView = newGaugeSummaryBlockView.filter(
                (vu) => !detachedVUlist.some((det) => det.basevu?.VisualUnitId === vu.basevu?.VisualUnitId)
            );
        }

        setVisualUnitsTable(newVisualUnits);
        setGaugeSummaryBlockView(newGaugeSummaryBlockView);
        updateContextData(newVisualUnits, newGaugeSummaryBlockView);

        if (addedVUlist.length === 0 && detachedVUlist.length > 0) {
            FoundationsGenericToaster('success', 'Reports successfully detached.');
        } else {
            FoundationsGenericToaster('success', 'Reports successfully attached.');
        }
    };
    // Function to update context when data changes
    const updateContextData = (updatedVisualUnits: VisualUnit[], updatedGaugeSummaryBlockView: VisualUnit[]) => {
        setAttachExistingReportData({
            visualUnitsTable: updatedVisualUnits,
            gaugeSummaryBlockView: updatedGaugeSummaryBlockView,
        })
    }

    return {
        onFind,
        onSave,
    };
};